export const mobileNoExp = /^[6-9]\d{9}$/;
export const vehicle_no = /^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$/;
